import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Topics from "../views/Topics.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/topics",
    name: "Topics",
    component: Topics
  }
];

const router = new VueRouter({
  routes,
  // always display top of the page when re-routed
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
